var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1013 5.30008H11.108M5.33464 13.8334H10.668C12.1407 13.8334 13.3346 12.6395 13.3346 11.1667V5.83341C13.3346 4.36066 12.1407 3.16675 10.668 3.16675H5.33464C3.86188 3.16675 2.66797 4.36066 2.66797 5.83341V11.1667C2.66797 12.6395 3.86188 13.8334 5.33464 13.8334ZM10.5013 8.50008C10.5013 9.88079 9.38201 11.0001 8.0013 11.0001C6.62059 11.0001 5.5013 9.88079 5.5013 8.50008C5.5013 7.11937 6.62059 6.00008 8.0013 6.00008C9.38201 6.00008 10.5013 7.11937 10.5013 8.50008Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.40f95facb7ea8c7769695e382f7bff12.svg";
export { ForwardRef as ReactComponent };